module.exports = __webpack_public_path__ + "5366760180c74b9301a144867edd5936.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mai.png
// module id = 786
// module chunks = 0